import { cn } from "@/lib/utils";
import { ReactNode } from "react";
import { cardClassName } from "./assistantClasses";

interface ConversationBubbleProps {
    isUserRequest?: boolean;
    message?: string;
    children?: ReactNode;
    className?: string;
}

/**
 * The user's request: a soft bubble on the right. On the assistant's side, a card (error with
 * « Réessayer », « charger plus », action, analysis, ticket forms); its plain text has no bubble
 * (MessageItem).
 */
const ConversationBubble = ({
    isUserRequest = false,
    message,
    children,
    className,
}: ConversationBubbleProps) => {
    const lines = message?.split("\n").map((line) => <p key={line}>{line}</p>);

    return isUserRequest ? (
        <div className="flex w-full animate-opacity justify-end">
            <div
                className={cn(
                    "max-w-[80%] whitespace-pre-wrap rounded-[22px] bg-assistant-lavender px-4 py-2.5 text-left text-base leading-6 text-primary-darkest",
                    className,
                )}
            >
                {lines}
                {children}
            </div>
        </div>
    ) : (
        <div
            className={cn(
                cardClassName,
                "w-full animate-opacity whitespace-pre-wrap p-4 text-left text-sm leading-relaxed text-primary-darkest",
                className,
            )}
        >
            {lines}
            {children}
        </div>
    );
};

export default ConversationBubble;
